import { colors } from '../theme';

/**
 * The Veriplus mark.
 *
 * The four paths, their weights and the box are the logo pack's
 * `brand/veriplus-mark-orange.svg`, character for character (D30), as the ops
 * console draws it (its D26). The page-2 artboards draw the two arcs at 12 in
 * the 34px sidebar; the user ruled for the pack everywhere. The box is grown
 * one unit on each side so the round cap on the plus cannot clip. Do not
 * redraw it or re-export it from a vector editor.
 *
 * `decorative` hides it from assistive tech where a wordmark beside it already
 * names the product, so a screen reader does not hear "Veriplus" twice.
 *
 * `pulse` is the loading state (D31, after the ops console's D30): the plus
 * alone breathes in opacity through `vp-pulse` in `theme/tokens.css`, and the
 * other three paths stay still. That rule stops under `prefers-reduced-motion`.
 */
export function BrandMark({
  size = 34,
  color = colors.brand,
  decorative = false,
  pulse = false,
}: {
  size?: number;
  color?: string;
  decorative?: boolean;
  pulse?: boolean;
}) {
  const a11y = decorative ? { 'aria-hidden': true } : { role: 'img', 'aria-label': 'Veriplus' };
  return (
    <svg width={size} height={size} viewBox="-1 -1 102 102" fill="none" {...a11y}>
      <path d="M24 32 Q24 16 40 16 L56 16" stroke={color} strokeWidth="13" strokeLinecap="round" />
      <path
        d="M10 48 L42 80 L78 32"
        stroke={color}
        strokeWidth="14"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M86 52 L86 64 Q86 84 66 84 L60 84"
        stroke={color}
        strokeWidth="13"
        strokeLinecap="round"
      />
      <path
        d="M87 4 L87 20 M79 12 L95 12"
        stroke={color}
        strokeWidth="9"
        strokeLinecap="round"
        className={pulse ? 'vp-pulse' : undefined}
      />
    </svg>
  );
}
